import { Checkbox } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import logo from "@/assets/credentially_logo.png";

export const CredentiallyCard = ({
    showResend,
    methods,
    onSubmit,
    mutation,
    isResend,
}) => {
    return (
        <Card size="lg" className="flex h-full flex-col">
            <div className="flex gap-3">
                <img src={logo} alt="Credentially Logo" className="h-8" />
                <h2 className="mb-3 text-xl font-semibold">Credentially</h2>
            </div>
            <div className="flex basis-full flex-col items-start gap-y-6">
                <div className="col-span-full">
                    <p className="mt-3 text-sm">
                        All clinicians are verified through Credentially, our
                        trusted third-party partner. Once you’ve signed up,
                        you’ll be redirected to their secure platform to
                        complete your credential checks. It’s quick,
                        straightforward, and only needs to be done once.
                    </p>
                </div>
                <div className="col-span-full">
                    <Checkbox
                        name="credentially_OK"
                        label="I accept"
                        labelPlacement="end"
                        className="w-fit"
                    />
                </div>
                {showResend && (
                    <div className="col-span-full mt-auto mb-6">
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={methods.handleSubmit((data) =>
                                onSubmit(data, { credentially_OK: 2 }),
                            )}
                            disabled={mutation.isPending}
                        >
                            {mutation.isPending && isResend
                                ? "Sending..."
                                : "Resend email"}
                        </Button>
                    </div>
                )}
            </div>
        </Card>
    );
};
